module.exports = __webpack_public_path__ + "static/media/logo-zelok.8ee01b6e.svg";